import { render, staticRenderFns } from "./headerCase.vue?vue&type=template&id=492f221a&scoped=true"
import script from "./headerCase.vue?vue&type=script&lang=js"
export * from "./headerCase.vue?vue&type=script&lang=js"
import style0 from "./headerCase.vue?vue&type=style&index=0&id=492f221a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f221a",
  null
  
)

export default component.exports